export type ToastsTranslation = {
  fetch: {
    '401': string;
    error: string;
    success: string;
  };
};

export const toastsTranslation: ToastsTranslation = {
  fetch: {
    '401': 'Twoja sesja wygasła, nastąpi przelogowanie',
    error: 'Wystąpił błąd. Spróbuj ponownie lub zgłoś błąd',
    success: 'Działanie zakończone sukcesem',
  },
};
